export default {
    changePageName (state,page_name){
        state.page_name = page_name;
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js